import { Props as ChipProps } from 'ui/elements/Chip';
import React from 'react';
import Logo from 'ui/domain/Logo';

interface Props {
  companyName: string;
  logoURL?: string;
  established?: string;
  subtitle?: string;
  logoSize?: number;
  raisingChip?: React.ReactElement<ChipProps>;
}

export default function CompanyColumn({
  companyName,
  logoURL,
  established,
  subtitle,
  logoSize = 60,
  raisingChip,
}: Props) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', minWidth: '14rem' }} className="u-quarter-padding-y">
      <Logo className="u-content-spacing-right" size={logoSize} type="company" url={logoURL} />
      <div>
        <h3 className="text-h4" style={{ lineHeight: '1.1' }}>
          {companyName}
        </h3>
        <span className="text-metadata">{subtitle ?? (established && <>Established in {established}</>)}</span>
        {raisingChip && <div>{raisingChip}</div>}
      </div>
    </div>
  );
}
